import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import Button from '@mui/material/Button';

const LinkButton = (props) => {
  const {
    history,
    location,
    match,
    staticContext,
    variant,
    to,
    onClick,
    // ⬆ filtering out props that `button` doesn’t know what to do with.
    ...rest
  } = props;
  const navigate = useNavigate();
  return (
    <Button
      variant={variant || 'outlined'}
      color='primary'
      {...rest}
      onClick={(event) => {
        onClick && onClick(event);
        navigate(to);
      }}
    />
  );
};

LinkButton.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default LinkButton;
